import { DrivingQuestionsConfig } from './DrivingQuestionsConfig';

// Example 1: Full configuration (default behavior)
export const FULL_CONFIG: DrivingQuestionsConfig = {
  driverLimits: {
    maxTotal: 4,
    maxAdditional: 3,
  },
  driverSelection: {
    type: 'buttons',
    prompt: 'Who will be driving? Maximum of {maxTotal} total drivers.',
    options: [
      {
        key: 'only_driver',
        text: 'I will be the only driver',
        showsAdditionalDrivers: false,
      },
      {
        key: 'additional_drivers',
        text: 'There are additional drivers',
        showsAdditionalDrivers: true,
      },
    ],
  },
  additionalDrivers: {
    prompt: 'Additional drivers (Maximum of {maxAdditional})',
    addButtonText: 'Add Driver',
    maxReachedMessage: 'Maximum of {maxAdditional} additional drivers allowed.',
  },
   questions: [
        {
        id: 'confirm_drivers',
        text: 'I understand that only named people will be driving the vehicle. I confirm that all drivers are 21+ with valid drivers license(s) and insurance.',
        required: true,
        },
        {
        id: 'speed_limit_agreement',
        text: 'I agree to drive 35MPH or less on roadways in the Moke or Honor LSV. Failure to do so will result in immediate termination of my rental without a refund.',
        required: true,
        },
        {
        id: 'damage_responsibility',
        text: 'I understand that there will be a $500 hold placed on my card upon arrival. I will be responsible for any and all damages.',
        required: true,
        },
        {
        id: 'return_charged',
        text: 'All overnight or multi-day rentals must be returned fully charged by 9am.',
        required: true,
        },
    ],
};

// Example 2: No driver selection prompt - just show agreement questions
export const NO_DRIVER_SELECTION_CONFIG: DrivingQuestionsConfig = {
  driverLimits: {
    maxTotal: 4,
    maxAdditional: 3,
  },
  // No driverSelection - means no "Who will be driving?" prompt
  additionalDrivers: {
    prompt: 'Additional drivers (Maximum of {maxAdditional})',
    addButtonText: 'Add Driver',
    maxReachedMessage: 'Maximum of {maxAdditional} additional drivers allowed.',
  },
  questions: [
    {
      id: 'confirm_drivers',
      text: 'I understand that only named people will be driving the vehicle...',
      required: true,
    },
  ],
};

// Example 3: Minimal configuration - only essential questions
export const MINIMAL_CONFIG: DrivingQuestionsConfig = {
  driverLimits: {
    maxTotal: 2,
    maxAdditional: 1,
  },
  // No driver selection, no additional drivers
  additionalDrivers: {
    prompt: 'Additional drivers (Maximum of {maxAdditional})',
    addButtonText: 'Add Driver',
    maxReachedMessage: 'Maximum of {maxAdditional} additional drivers allowed.',
  },
  questions: [
    {
      id: 'damage_responsibility',
      text: 'I understand that there will be a $500 hold placed on my card...',
      required: true,
    },
  ],
};

// Example 4: Conditional questions based on driver count
export const CONDITIONAL_QUESTIONS_CONFIG: DrivingQuestionsConfig = {
  driverLimits: {
    maxTotal: 4,
    maxAdditional: 3,
  },
  driverSelection: {
    type: 'buttons',
    prompt: 'Who will be driving? Maximum of {maxTotal} total drivers.',
    options: [
      {
        key: 'only_driver',
        text: 'I will be the only driver',
        showsAdditionalDrivers: false,
      },
      {
        key: 'additional_drivers',
        text: 'There are additional drivers',
        showsAdditionalDrivers: true,
      },
    ],
  },
  additionalDrivers: {
    prompt: 'Additional drivers (Maximum of {maxAdditional})',
    addButtonText: 'Add Driver',
    maxReachedMessage: 'Maximum of {maxAdditional} additional drivers allowed.',
  },
  questions: [
    {
      id: 'confirm_drivers',
      text: 'I understand that only named people will be driving the vehicle...',
      required: true,
    },
    {
      id: 'additional_driver_insurance',
      text: 'I confirm that all additional drivers have valid insurance.',
      required: true,
      showWhen: {
        field: 'is_only_driver',
        value: false, // Only show when there are additional drivers
      },
    },
    {
      id: 'speed_limit_agreement',
      text: 'I agree to drive 35MPH or less...',
      required: true,
    },
  ],
};

// Example 5: Different driver selection type
export const DROPDOWN_CONFIG: DrivingQuestionsConfig = {
  driverLimits: {
    maxTotal: 6,
    maxAdditional: 5,
  },
  driverSelection: {
    type: 'dropdown',
    prompt: 'How many people will be driving? Maximum of {maxTotal} total drivers.',
    options: [
      {
        key: 'only_driver',
        text: 'Just me (1 driver)',
        showsAdditionalDrivers: false,
      },
      {
        key: 'additional_drivers',
        text: 'Multiple drivers',
        showsAdditionalDrivers: true,
      },
    ],
  },
  additionalDrivers: {
    prompt: 'Additional drivers (Maximum of {maxAdditional})',
    addButtonText: 'Add Another Driver',
    maxReachedMessage: 'Maximum of {maxAdditional} additional drivers allowed.',
  },
  questions: [
    {
      id: 'confirm_drivers',
      text: 'I understand that only named people will be driving the vehicle...',
      required: true,
    },
  ],
};

// Example 6: Empty configuration - for invalid API responses or empty data
export const EMPTY_CONFIG: DrivingQuestionsConfig = {
  driverLimits: {
    maxTotal: 1,
    maxAdditional: 0,
  },
  additionalDrivers: {
    prompt: 'Additional drivers (Maximum of {maxAdditional})',
    addButtonText: 'Add Driver',
    maxReachedMessage: 'Maximum of {maxAdditional} additional drivers allowed.',
  },
  questions: [],
};
